/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';

store( 'wds/tabbed-content-block', {
	state: {
		get checkTabContent() {
			const { ref, attributes } = getElement();
			const { openTab } = getContext();

			if ( ! ref ) {
				return false;
			}

			return openTab === ref.getAttribute( 'data-id' ) ? false : true;
		},
	},
	actions: {
		updateCurrentTab: ( { target } ) => {
			const context = getContext();
			target = target.closest( 'button' );
			const tabId = target.getAttribute( 'aria-controls' );
			context.openTab = tabId;
			const callbacks = store( 'wds/tabbed-content-block' ).callbacks;
			callbacks.updateIsActive();
		},
		setWrapperMinHeight: () => {
			const { ref } = getElement();
			const tabs = ref.querySelectorAll(
				'.wp-block-wds-tabbed-content-child'
			);

			let minHeight = 0;

			tabs.forEach( ( tab ) => {
				if ( tab.offsetHeight > minHeight ) {
					minHeight = tab.offsetHeight;
				}
			} );
			tabs.forEach( ( tab ) => {
				tab.style.minHeight = `${ minHeight }px`;
			} );

			const mediaQuery = window.matchMedia('(min-width: 782px)');
			if ( ref.classList.contains( 'vertical-layout' )  && mediaQuery.matches ) {
				ref.style.minHeight = `${ minHeight }px`;
			} else {
				const tabsList = ref.querySelector( '.tabs-list' );
				const totalHeight = tabsList.offsetHeight + minHeight;
				ref.style.minHeight = `${ totalHeight }px`;
			}
		},

		firstTabClick: () => {
			const context = getContext();
			const { ref } = getElement();
			const tabId = ref
				.querySelector(
					'.tabs-list .tab-list-item:first-child button:first-child'
				)
				.getAttribute( 'aria-controls' );
			context.openTab = tabId;
			const callbacks = store( 'wds/tabbed-content-block' ).callbacks;
			callbacks.updateIsActive();
		},
	},
	callbacks: {
		initTab: () => {
			const actions = store( 'wds/tabbed-content-block' ).actions;
			actions.setWrapperMinHeight();
			actions.firstTabClick();

			const { ref } = getElement();
			ref.classList.remove('is-loading');
		},
		updateIsActive: () => {
			const { ref } = getElement();
			const tagElement = ref.classList.contains(
				'wp-block-wds-tabbed-content-block'
			)
				? ref
				: ref.parentNode.parentNode;
			const buttonTag = ref.classList.contains(
				'wp-block-wds-tabbed-content-block'
			)
				? ref.querySelector(
						'.tabs-list .tab-list-item:first-child button:first-child'
				  )
				: ref;
			const tabListItems = tagElement.querySelectorAll(
				'.tabs-list .tab-list-item button'
			);
			tabListItems.forEach( ( item ) => {
				if ( item === buttonTag ) {
					item.classList.add( 'active' );
					item.setAttribute( 'aria-selected', 'true' );
				} else {
					item.classList.remove( 'active' );
					item.setAttribute( 'aria-selected', 'false' );
				}
			} );
		},
	},
} );
